import React from 'react'
import { Button, Grid } from '@mui/material'
import ReactModal from 'react-modal'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Logo from '../../../../assets/images/logo_bg.png'
import './SuccessModal.scss'

type Props = {
  isOpen: boolean
  setIsOpen?: (isOpen: boolean) => void
}
const c = 'success-modal'

const SuccessModal = (props: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const roulettePrize = localStorage.getItem('roulettePrize')

  return (
    <ReactModal
      shouldCloseOnOverlayClick
      className='success-modal-container'
      isOpen={props.isOpen}
      onRequestClose={() => {
        localStorage.removeItem('pendingOrderSuccess')
        sessionStorage.removeItem('orderCompleted')
        localStorage.removeItem('rouletteWinningPrize')
        localStorage.removeItem('roulettePrize')
        localStorage.removeItem('successMessage')
        props.setIsOpen?.(false)
        navigate('/')
      }}
    >
      <div className={c}>
        <div className={`${c}-header`}>
          <div className={`${c}__header-image`}>
            <img src={Logo} alt='logo' height={100} width={100} />
          </div>
        </div>
        <div className={`${c}__content`}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className={`${c}__content-text`}>
                {t('OPERATOR_CALL_SOON')}
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={`${c}__content-text`}>
                {t('THANKS_FOR_ORDER')}☀️
              </div>
            </Grid>
            {roulettePrize && (
              <Grid item xs={12}>
                <div
                  className={`${c}__content-text`}
                  style={{ color: '#ff1647', fontWeight: 'bold' }}
                >
                  🎉 {t('YOU_WON')}: {roulettePrize}! 🎉
                </div>
              </Grid>
            )}
          </Grid>
          <div className={`${c}__content-submit`}>
            <Button
              variant='contained'
              onClick={() => {
                localStorage.removeItem('pendingOrderSuccess')
                sessionStorage.removeItem('orderCompleted')
                localStorage.removeItem('rouletteWinningPrize')
                localStorage.removeItem('roulettePrize')
                localStorage.removeItem('successMessage')
                navigate('/')
                props.setIsOpen?.(false)
              }}
              sx={{
                backgroundColor: '#ff1647',
                textTransform: 'none',
                fontWeight: 'bold',
                width: '100%',
                '&:hover': { backgroundColor: '#cc1138' },
              }}
            >
              {t('CLOSE')}
            </Button>
          </div>
        </div>
      </div>
    </ReactModal>
  )
}

export default SuccessModal
